import { createFileRoute } from '@tanstack/react-router';
import { ReviewDetailPage } from './ReviewDetailPage';

export const Route = createFileRoute(
  '/_protected/admin/internal-tools/review-receipts/$receiptReviewId/',
)({
  component: ReviewDetailPage,
});
